"use client";
import { SmartLink } from "@/Components";
import useResponsive from "@/Hooks/useResponsive";
import { AdsSectionProps } from "@/Templates/SectionsProps";
import { FC } from "react";
import { SmartImage } from "../../../Components";

const Ads: FC<AdsSectionProps> = ({ dataSource }) => {
  const { isMobile } = useResponsive();
  const showSingleItemOnMobile =
    isMobile && dataSource.Items.every((item) => !item.HasAdvertisement);
  const items = showSingleItemOnMobile
    ? dataSource.Items.slice(0, 1)
    : dataSource.Items;

  return (
    <section className="section section-ads">
      <div className="container-fluid">
        <div className="row">
          {items.map((item) => (
            <div key={item.Id} className="col-md-6 col-lg-3 col-sm-6">
              <div className="card w-100">
                <SmartLink href={item.Link} rel="nofollow" target="_blank">
                  <SmartImage
                    width={450}
                    height={160}
                    className="card-img"
                    src={item.ImageUrl}
                    alt={item.AltText}
                  />
                </SmartLink>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Ads;
